// src/features/legacy-quantilia/issuer_events/columns.tsx

import { formatNumber, parseDate } from "@/lib/utils";
import { ColumnDef } from "@tanstack/react-table";

// Enum mappings from Ruby IssuerEventConcern::Enums
const timeOfTheDayMap: Record<number, string> = {
  0: "Before Market",
  1: "Morning",
  2: "After Market",
  3: "Afternoon",
};

const eventTypeMap: Record<number, string> = {
  0: "Earnings",
  1: "Council",
  2: "Bank Holiday",
  3: "Press Conference",
  4: "Other",
  5: "Political",
};

export type IssuerEvent = {
  id: number;
  event_date: string | null;
  time_of_the_day: number | null;
  event_type: number | null;
  remark: string | null;
  issuer_id: number;
  created_at: string;
  updated_at: string;
};

export const issuer_event_columns: ColumnDef<IssuerEvent>[] = [
  {
    accessorKey: "id",
    header: "Id",
  },
  {
    accessorKey: "event_date",
    header: "Event Date",
    cell: ({ row }) => {
      const value = row.getValue<string | null>("event_date");
      return value ? parseDate(value) : "";
    },
  },
  {
    accessorKey: "time_of_the_day",
    header: "Time of Day",
    cell: ({ row }) => {
      const value = row.getValue<number | null>("time_of_the_day");
      return value != null ? timeOfTheDayMap[value] || formatNumber(value) : "";
    },
  },
  {
    accessorKey: "event_type",
    header: "Event Type",
    cell: ({ row }) => {
      const value = row.getValue<number | null>("event_type");
      return value != null ? eventTypeMap[value] || formatNumber(value) : "";
    },
  },
  {
    accessorKey: "remark",
    header: "Remark",
    cell: ({ row }) => {
      const value = row.getValue<string | null>("remark");
      return value ?? "";
    },
  },
  {
    accessorKey: "issuer_id",
    header: "Issuer",
    cell: ({ row }) => {
      const value = row.getValue<number>("issuer_id");
      return formatNumber(value);
    },
  },
  {
    accessorKey: "created_at",
    header: "Created At",
    cell: ({ row }) => {
      const value = row.getValue<string>("created_at");
      return parseDate(value);
    },
  },
  {
    accessorKey: "updated_at",
    header: "Updated At",
    cell: ({ row }) => {
      const value = row.getValue<string>("updated_at");
      return parseDate(value);
    },
  },
];
